module.exports = function (cX9) {
  return function (cXa) {
    return cX9.apply(null, cXa);
  };
};